import { Store } from 'redux';
import { EpiAppState } from '../Store/Types';
import { updateEpiModel, updateValuta } from '../Store/EpiContext/Actions';
import { getValutaBenevnelse } from './ContentApi';
import contentApi from './ContentApi';

import { getDateNow } from './DateResolver';

export default function InitEpiMessages<T>(store: Store<EpiAppState<T>>, contentLink: string): void {
    getContent<T>(contentLink, store);
}

function getContent<T>(contentLink: string, store: Store<EpiAppState<T>>) {
    const timeOfCall = getDateNow();

    contentApi
        .getContentByContentLink<T>(contentLink)
        .then(res => res.json())
        .then((data) => {
            store.dispatch(updateEpiModel(data, timeOfCall, false));
        })
        .catch((reason: any) => {
            store.dispatch(updateEpiModel(null, timeOfCall, true));
        });

    getValutaBenevnelse<T>()
        .then(res => res.json())
        .then((data) => {
            const valuta: string = data.ValutaBenevnelse;
            if (valuta !== "" && valuta !== null && valuta !== undefined)
                store.dispatch(updateValuta(valuta));
        });
}
